import { render, staticRenderFns } from "./SlideOptionsInputV2.vue?vue&type=template&id=0c3265f2&scoped=true&"
import script from "./SlideOptionsInputV2.vue?vue&type=script&lang=js&"
export * from "./SlideOptionsInputV2.vue?vue&type=script&lang=js&"
import style0 from "./SlideOptionsInputV2.vue?vue&type=style&index=0&id=0c3265f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3265f2",
  null
  
)

export default component.exports